export const outletsRequestDynamicContextResponse_v1_schema = {
  type: 'object',
  properties: {
    target: {
      type: 'string',
    },
    isRootNodeHttps: {
      type: 'boolean',
    },
    isConfigurationMode: {
      type: 'boolean',
    },
    areDynamicOutletsEnabled: {
      type: 'boolean',
    },
    isPreviewActive: {
      type: 'boolean',
    },
    plugins: [],
  },
  required: [],
};
